import { useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import { useSignMessage } from "wagmi";
import { $api } from "@/lib/api-client";
import { buildStatementVoteMessage } from "@/lib/statement/voteMessage";

export function useCastStatementVote(statementId: string, index: number) {
  const { signMessageAsync, isPending: isSigning } = useSignMessage();
  const pending = useRef<{ key: string; nonce: string } | null>(null);
  const post = $api.useMutation("post", "/statements/{id}/votes");
  const qc = useQueryClient();

  return {
    isPending: post.isPending || isSigning,
    castAsync: async (
      support: "yes" | "no",
      source: "wallet" | "stake",
      amount: string, // wei
      wallet: string,
    ) => {
      const key = JSON.stringify([
        support,
        source,
        amount,
        wallet.toLowerCase(),
      ]);
      if (pending.current?.key !== key) {
        pending.current = { key, nonce: crypto.randomUUID() };
      }
      const nonce = pending.current.nonce;
      const message = buildStatementVoteMessage({
        index,
        support,
        source,
        amount,
        wallet,
        nonce,
      });
      const signature = await signMessageAsync({ message });
      await post.mutateAsync({
        params: { path: { id: statementId } },
        body: { support, source, amount, signature, message, nonce },
      });
      pending.current = null;
      qc.invalidateQueries({
        queryKey: ["get", "/statements/{id}/votes/mine"],
      });
      qc.invalidateQueries({
        queryKey: ["get", "/statements/{id}/votes/budget"],
      });
    },
  };
}
